module.exports = __webpack_public_path__ + "media/books/ArtBooksProduct-83e97aaf.png";